"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * 查询元素在页面中的坐标，单位：px
 * @param {string} selector 元素选择器
 * @return {Promise<Object>} 元素坐标
 */
var queryRect = exports.queryRect = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(selector) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              wx.createSelectorQuery().select(selector).boundingClientRect(resolve).exec();
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function queryRect(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * 将内联样式字符串解析为对象形式
 * @param {string} styleStr 内联样式，e.g. 'color: red; transform: translate(20px, 30px)'
 * @return {Object} 内联样式对象，e.g. {color:"red",transform:"translate(20px, 30px)"}
 */


exports.deepClone = deepClone;
exports.deepEqual = deepEqual;
exports.deepAssign = deepAssign;
exports.delay = delay;
exports.compareVersion = compareVersion;
exports.appendUrlParam = appendUrlParam;
exports.toAbsolutePath = toAbsolutePath;
exports.semanticRemainTime = semanticRemainTime;
exports.padStart = padStart;
exports.parseInlineStyle = parseInlineStyle;
exports.toInlineStyle = toInlineStyle;
exports.entriesToObject = entriesToObject;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * 封装常用的通用功能函数
 */

/**
 * 深度拷贝
 * @param source 源参数
 * @return {*}   源参数的深度拷贝
 */
function deepClone(source) {
  if (!((typeof source === "undefined" ? "undefined" : _typeof(source)) === "object" && source !== null)) return source;

  var clone = Array.isArray(source) ? [] : {};
  for (var p in source) {
    clone[p] = deepClone(source[p]);
  }return clone;
}

/**
 * 深度判等
 * 两个对象结构和数据完全一致，即认为相等，而不要求是同一引用
 * @param o1  参数1
 * @param o2  参数2
 * @return {boolean}  参数1、参数2 是否相等
 */
function deepEqual(o1, o2) {
  if ((typeof o1 === "undefined" ? "undefined" : _typeof(o1)) !== "object" || (typeof o2 === "undefined" ? "undefined" : _typeof(o2)) !== "object") return o1 === o2;

  for (var p in o1) {
    if (!deepEqual(o1[p], o2[p])) return false;
  }

  for (var q in o2) {
    if (!(q in o1)) return false;
  }

  return true;
}

/**
 * 深度覆盖
 * 将源对象的值覆盖目标对象，相同结构相同参数部分直接覆盖，其它部分保持不变
 * @param target 目标对象
 * @param sources  若干个源对象
 *
 * e.g.
 * 修改前：
 *    target = {x: 1, y: {a: 1, b:1 }, z: 1};
 *    source = {x: 2, y: {a: 2}};
 *
 * 修改后：
 *    target = {x: 2, y: {a: 2, b:1 }, z: 1}
 */
function deepAssign(target) {
  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  if ((typeof target === "undefined" ? "undefined" : _typeof(target)) !== "object") {
    console.error('[deepAssign] bad parameters, target should be an object, parameters:', arguments);
    return target;
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = sources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var source = _step.value;

      if (source != null && (typeof source === "undefined" ? "undefined" : _typeof(source)) !== "object") {
        console.warn('[deepAssign] bad parameters, source should all be object, parameters:', arguments);
        continue;
      }

      for (var p in source) {
        if (_typeof(target[p]) === "object" && _typeof(source[p]) === "object") deepAssign(target[p], source[p]);else target[p] = source[p];
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return target;
}

/**
 * 设置延时
 * @param {number} ms  延迟时长，单位：ms
 * @return {Promise}
 */
function delay(ms) {
  return new Promise(function (resolve, reject) {
    setTimeout(resolve, ms);
  });
}

/**
 * 版本号比较
 * @param {string} v1 版本号1，形如"2.2.3"
 * @param {string} v2 版本号2
 * @return {number} 比较结果： -1 小于 | 0 等于 | 1 大于
 */
function compareVersion(v1, v2) {
  var seq1 = v1.split(".").map(function (subVersion) {
    return parseInt(subVersion);
  });
  var seq2 = v2.split(".").map(function (subVersion) {
    return parseInt(subVersion);
  });

  var len1 = seq1.length,
      len2 = seq2.length,
      commonLen = Math.min(len1, len2);
  for (var i = 0; i < commonLen; ++i) {
    if (seq1[i] != seq2[i]) return seq1[i] < seq2[i] ? -1 : 1;
  }

  return len1 == len2 ? 0 : len1 < len2 ? -1 : 1;
}

/**
 * 拼接参数，注：当前只针对小程序标准url，暂未考虑含#号/多?号等特殊url情形
 * @param {string} url 原url
 * @param {Object} extraParams 新增参数
 * @return {string} 新url
 */
function appendUrlParam(url, extraParams) {
  if (!extraParams) return url;

  var _url$split = url.split('?'),
      _url$split2 = _slicedToArray(_url$split, 2),
      path = _url$split2[0],
      _url$split2$ = _url$split2[1],
      queryStr = _url$split2$ === undefined ? "" : _url$split2$;

  var params = {};
  queryStr.split('&').forEach(function (paramStr) {
    var _paramStr$split = paramStr.split('='),
        _paramStr$split2 = _slicedToArray(_paramStr$split, 2),
        name = _paramStr$split2[0],
        value = _paramStr$split2[1];

    if (name && value !== undefined) params[name] = value;
  });

  var newParams = Object.assign({}, params, extraParams);
  var newQueries = [];
  for (var name in newParams) {
    newQueries.push(name + '=' + newParams[name]);
  }return newQueries.length > 0 ? path + '?' + newQueries.join('&') : url;
}

/**
 * 将小程序相对路径转为绝对路径
 * @param {string} relativePath 相对路径
 * @param {string} curPath  当前路径
 * @return {string} 绝对路径
 */
function toAbsolutePath(relativePath, curPath) {
  if (!(typeof relativePath === 'string' && typeof curPath === 'string')) {
    console.error('[toAbsolutePath] bad params, relativePath:', relativePath, 'curPath:', curPath);
    return relativePath;
  }

  if (relativePath[0] === '/') //已经是绝对路径
    return relativePath;

  var levels = curPath.split('/').slice(0, -1).concat(relativePath.split('/'));
  var absoluteLevels = [];
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = levels[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var level = _step2.value;

      if (level === '' || level === '.') continue;
      if (level === '..') {
        absoluteLevels.pop();
        continue;
      }
      absoluteLevels.push(level);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return '/' + absoluteLevels.join('/');
}

/**
 * 剩余时间的语义化表示
 * @param {number} remainMs 剩余时间，单位：毫秒
 * @param {number} remainderInterval 最小时间间隔，不足1秒的部分以此计数
 * @param {string} topLevel 顶层间隔：day|hour|minute|second， 如顶层间隔为'hour'，则返回结果为形如 27小时3分钟 而不是 1天3小时3分钟
 * @return {{days: number, hours: number, minutes: number, seconds: number, remainderIntervals: number}} 剩余days天hours小时minutes分钟seconds秒remainderIntervals间隔
 */
function semanticRemainTime(_ref) {
  var remainMs = _ref.remainMs,
      _ref$topLevel = _ref.topLevel,
      topLevel = _ref$topLevel === undefined ? 'day' : _ref$topLevel,
      _ref$remainderInterva = _ref.remainderInterval,
      remainderInterval = _ref$remainderInterva === undefined ? 1000 : _ref$remainderInterva;

  var SCALES = {
    second: 1000,
    minute: 60 * 1000,
    hour: 60 * 60 * 1000,
    day: 24 * 60 * 60 * 1000
  };

  var topScale = SCALES[topLevel];

  var _map$map = [SCALES.day, SCALES.hour, SCALES.minute, SCALES.second, remainderInterval].map(function (scale, idx, arr) {
    return scale >= topScale || idx === 0 ? remainMs / scale : remainMs % arr[idx - 1] / scale;
  }).map(Math.floor),
      _map$map2 = _slicedToArray(_map$map, 5),
      days = _map$map2[0],
      hours = _map$map2[1],
      minutes = _map$map2[2],
      seconds = _map$map2[3],
      remainderIntervals = _map$map2[4];

  return {
    days: days, hours: hours, minutes: minutes, seconds: seconds, remainderIntervals: remainderIntervals
  };
}

/**
 * 若字符串长度小于指定长度，则在前方拼接指定字符
 * es6中string的padStart函数目前存在兼容性问题，暂以此替代
 * @param str 字符串
 * @param minLen 指定长度
 * @param leadChar 指定字符
 * @return {string} 新字符串
 */
function padStart(str, minLen, leadChar) {
  str = String(str);
  while (str.length < minLen) {
    str = leadChar + str;
  }return str;
}function parseInlineStyle(styleStr) {
  if (!styleStr) return {};

  var styleObj = {};

  var declarations = styleStr.split(';');
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = declarations[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var declaration = _step3.value;

      var _declaration$split$ma = declaration.split(':').map(function (part) {
        return part.replace(/^\s*|\s*$/g, '');
      }),
          _declaration$split$ma2 = _slicedToArray(_declaration$split$ma, 2),
          prop = _declaration$split$ma2[0],
          value = _declaration$split$ma2[1];

      styleObj[prop] = value;
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return styleObj;
}
/**
 * 将样式对象转为内联样式字符串
 * @param {Object} styleObj 内联样式对象，e.g. {color:"red",transform:"translate(20px, 30px)"}
 * @return {string} 内联样式，e.g. 'color: red; transform: translate(20px, 30px)'
 */
function toInlineStyle(styleObj) {
  var declarations = [];
  for (var prop in styleObj) {
    declarations.push(prop + ":" + styleObj[prop]);
  }return declarations.join('; ');
}

function entriesToObject(entries) {
  var obj = {};
  if (entries && Symbol.iterator in entries) {
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = entries[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var _ref3 = _step4.value;

        var _ref4 = _slicedToArray(_ref3, 2);

        var key = _ref4[0];
        var value = _ref4[1];

        obj[key] = value;
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    return obj;
  } else {
    return entries || {};
  }
}